import moment from "moment";
import { diff } from 'deep-diff';

const weekMapping = {
  id1: "week1",
  id2: "week2",
  id3: "week3",
  id4: "week4",
  id5: "week5",
  id6: "week6",
  id7: "week7",
  id8: "week8",
};


const week8Days = {
  id1id: "day1",
  id2id: "day2",
  id3id: "day3",
  id4id: "day4",
  id5id: "day5",
  id6id: "day6",
  id7id: "day7",

};

const getWBState = {
  wb: {
    data: [],
    weeks: [],
    columns: [],
    isClick: false,
    hasMore: true,
    currentPage: 1,
    totalItems: 0,
    totalPages: 1,
    pageSize: 50,

    currentCompanyId: null,
    sortByWeek: null,
    sortByWeekLastDay8: null,
    isAscending: false,
    sortPrice: false,
    sortStock: false,
    stockScladFbs: false,
    sorTarticle: false,
    averageOrdersBool: false,
    daysOfStockBool: false,
    turnoverVersion2Bool: false,
    sortedProducts: [],
    searchValue: "",
    isSearching: false,
    sortField: null,
    sortDir: "desc",
    isSorting: false,
  },
  loading: false,
  error: null,
};
// Функция для обновления вложенных значений
const getWaldberisListReducer = (state = getWBState, action) => {
  switch (action.type) {
    case "FETCH_WB_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "FETCH_WB_SUCCESS": {
      const newData = action.payload.data || [];

      const filteredData = state.wb.currentCompanyId
        ? newData.filter((item) => item.companiID === state.wb.currentCompanyId)
        : newData;

      const weeks = Array.isArray(action.payload.weeks)
        ? action.payload.weeks
        : [];

      const updatedWeeks = weeks.map((week, index) => ({
        ...week,
        id: `id${index + 1}`,
        days: Object.entries(week.days || {}).map(([, day], dayIndex) => ({
          ...day,
          id: `id${dayIndex + 1}id`,
        })),
      }));

      const transformedColumns = [
        { id: "name", label: "Товар" },
        { id: "price", label: "Цена" },
        { id: "stockSeller", label: "Остатки FBS" },
        { id: "stock", label: "Остатки FBO" },
        ...updatedWeeks.map((week, index) => ({
          id: week.id || index,
          label: (
            <>
              {moment(week.startDate).format("L")}
              <br />
              {moment(week.endDate).format("L")}
            </>
          ),
        })),
      ];

      const days = updatedWeeks[7]?.days || [];

      const transformedDays = days.map((day) => ({
        id: day.id,
        label: `${moment(day.date).format("L")}`,
      }));

      const previousColumns = state.wb.columns || [];

      const newColumns = [
        ...transformedColumns,
        ...transformedDays,

        { id: "Ads", label: "Заказы в день, шт" },
        { id: "idc", label: "Остатка хватит на дн FBO" },
        { id: "idcfbs", label: "Остатка хватит на дн FBS" },
        { id: "feedbackRating", label: "Рейтинг" },
        { id: "avgPosition", label: "Средняя позиция" },
        { id: "visibility", label: "Видимость" },
        { id: "strategy", label: "Стратегия" },
        { id: "marketing", label: "Маркетинг" },
        { id: "quality", label: "Качество" },
        { id: "content", label: "Контент" },
      ];

      const mergedColumns = previousColumns.concat(
        newColumns.filter(
          (newCol) => !previousColumns.some((oldCol) => oldCol.id === newCol.id)
        )
      );

      return {
        ...state,
        loading: false,
        error: null,
        wb: {
          ...state.wb,

          // ВАЖНО:
          // для Pagination мы НЕ добавляем товары к старым,
          // а заменяем data на текущую страницу
          data: filteredData,

          weeks: updatedWeeks,
          columns: mergedColumns,

          totalItems: action.payload.totalItems ?? 0,
          totalPages: action.payload.totalPages ?? 1,
          currentPage: action.payload.currentPage ?? 1,
          pageSize: action.payload.pageSize ?? state.wb.pageSize ?? 50,
          hasMore: Boolean(action.payload.hasMore),

          sortField: action.payload.sortField ?? state.wb.sortField ?? "",
          sortDir: action.payload.sortDir ?? state.wb.sortDir ?? "desc",

          isClick: state.wb.isClick,
          searchValue: state.wb.searchValue,

          sortByWeek: state.wb.sortByWeek,
          sortPrice: state.wb.sortPrice,
          sorTarticle: state.wb.sorTarticle,
          sortByWeekLastDay8: state.wb.sortByWeekLastDay8,
          averageOrdersBool: state.wb.averageOrdersBool,
          daysOfStockBool: state.wb.daysOfStockBool,
          turnoverVersion2Bool: state.wb.turnoverVersion2Bool,
        },
      };
    }

    case "FETCH_WB_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_WB_COMMENT":
      const findComment = state.wb.data.find(item => item.id === action.payload.id);

      if (findComment) {
        const updatedData = state.wb.data.map(item =>
          item.id === action.payload.id
            ? {
              ...item,
              comments: {
                ...item.comments,
                [action.payload.commentType]: {
                  value: action.payload.comments,
                  date: action.payload.date,
                },
              },
            }
            : item
        );

        return {
          ...state,
          wb: {
            ...state.wb,
            data: updatedData,
          },
        };
      }

      return state; // Если элемент не найден

    case "REORDER_WB_PRODUCTS":
      return {
        ...state,
        wb: {
          ...state.wb,
          data: action.payload,
        },
      };

    case "REORDER_WB_COLUMNS":
      return {
        ...state,
        wb: {
          ...state.wb,
          columns: action.payload, // Сохраняем новый порядок колонок
        },
      };

    case "CLICK_ROWS_WB":
      return {
        ...state,
        wb: {
          ...state.wb,
          isClick: action.payload, // Это должно переключать значение
        },
      };

    case "UPDATE_CURRENT_PAGE_WB":
      return {
        ...state,
        wb: {
          ...state.wb,
          currentPage: action.payload, // Обновление currentPage
        },
      };

    case "SET_CURRENT_COMPANY_WB":
      return {
        ...state,
        wb: {
          ...state.wb,
          currentCompanyId: action.payload, // Устанавливаем текущую компанию
          currentPage: 1,
          data: []
        },
      };




    // это из клиента подкрутки обновляем сортировку
    case "SORT_WEEKS_BY_DATE_UPDATE_WB":
      // Проверяем, существует ли неделя для сортировки
      if (state.wb.sortByWeek) {
        const isAscending = state.wb.isAscending;
        let sortDate = [...state.wb.data].sort((a, b) => {
          // Используем state.wb.sortByWeek для правильного доступа
          const aPercentage = a.weeks[state.wb.sortByWeek]?.totalPercentage || 0;
          const bPercentage = b.weeks[state.wb.sortByWeek]?.totalPercentage || 0;
          return isAscending ? bPercentage - aPercentage : aPercentage - bPercentage;
        });

        return {
          ...state,
          wb: {
            ...state.wb,
            data: sortDate,
            sortByWeek: state.wb.sortByWeek, // Сохраняем текущую неделю для сортировки
            isAscending,
            sortStock: false,
            stockScladFbs: false,
            sorTarticle: false,
            sortByWeekLastDay8: null,
          },
        };
      }
      return state;
    // здесь назначить сортировку для недель
    case "SORT_WEEKS_BY_DATE_WB": {
      const weekName = action.payload; // Получаем название недели из Action
      if (weekName) {
        const weekIndex = weekMapping[weekName]; // Находим индекс недели по идентификатору

        // Проверяем, существует ли неделя для сортировки
        if (weekIndex) {
          // Проверяем текущую сортировку для этой недели
          const isAscending = state.wb.sortByWeek === weekIndex ? !state.wb.isAscending : true;

          // Сортировка данных в зависимости от текущего направления
          state.wb.data.sort((a, b) => {
            const aPercentage = a.weeks[weekIndex]?.totalPercentage || 0;
            const bPercentage = b.weeks[weekIndex]?.totalPercentage || 0;
            return isAscending ? bPercentage - aPercentage : aPercentage - bPercentage;
          });

          return {
            ...state,
            wb: {
              ...state.wb,
              sortByWeek: weekIndex, // Сохраняем текущую неделю для сортировки
              isAscending, // Добавляем флаг для направления сортировки
              sortPrice: false,
              sortStock: false,
              stockScladFbs: false,
              sorTarticle: false,
              sortByWeekLastDay8: null,
            },
          };
        }
      }

      return state; // Возвращаем текущее состояние, если неделя не найдена
    }

    // сортировка для цены
    case "SORT_PRICE_WB":
      const isAscending = !state.wb.isAscending
      return {
        ...state,
        wb: {
          ...state.wb,
          sortPrice: !state.wb.sortPrice,
          sortPrice: true,
          sortStock: false,
          stockScladFbs: false,
          sorTarticle: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          data: state.wb.data.sort((a, b) => {
            return state.wb.isAscending ? (a.price.sizes[0].price || 0) - (b.price.sizes[0].price || 0) : (b.price.sizes[0].price || 0) - (a.price.sizes[0].price || 0);
          }),
        },
      };


    // Сортировка по остатку товара
    case "SORT_STOCK_WB": {
      const isAscending = !state.wb.isAscending; // Объявляем переменную перед использованием
      return {
        ...state,
        wb: {
          ...state.wb,
          sortPrice: false,
          sortStock: true,
          stockScladFbs: false,
          sorTarticle: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          data: state.wb.data.sort((a, b) => {
            return isAscending
              ? (b.stock || 0) - (a.stock || 0)
              : (a.stock || 0) - (b.stock || 0);
          }),
        },
      };
    }


    case "SORT_STOCK_WB_FBS": {
      const isAscending = !state.wb.isAscending; // Объявляем переменную перед использованием
      return {
        ...state,
        wb: {
          ...state.wb,
          sortPrice: false,
          sortStock: false,
          stockScladFbs: true,
          sorTarticle: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          data: state.wb.data.sort((a, b) => {
            return isAscending
              ? (b.stockSclad || 0) - (a.stockSclad || 0)
              : (a.stockSclad || 0) - (b.stockSclad || 0);
          }),
        },
      };
    }



    // сортировка по артикулу товара
    case "SORT_ACTICULE_WB": {
      const isAscending = !state.wb.isAscending; // Объявляем переменную перед использованием
      return {
        ...state,
        wb: {
          ...state.wb,
          sortPrice: false,
          sortStock: false,
          stockScladFbs: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          sorTarticle: true,
          data: state.wb.data.sort((a, b) => {
            return isAscending
              ? (b.nmID || 0) - (a.nmID || 0)
              : (a.nmID || 0) - (b.nmID || 0);
          }),
        },
      };
    }



    // сортировка по дням для последней недели
    case "SORT_LASTWEEKDAY8_WB": {
      const weekName = action.payload; // Получаем название недели из Action
      console.log(weekName, "action weekName");

      if (weekName) {
        const weekKey = week8Days[weekName]; // Получаем строковый ключ, например "day1"
        console.log(weekKey, "weekKey");

        if (weekKey) {
          // Проверяем текущую сортировку для этой недели
          const isAscending = state.wb.sortByWeekLastDay8 === weekKey ? !state.wb.isAscending : true;

          // Создаем копию массива перед сортировкой
          const sortedData = [...state.wb.data].sort((a, b) => {
            // Проверяем, что `week8` существует и содержит нужный день, иначе 0
            const aPercentage = a.weeks.week8?.[weekKey]?.total ?? 0;
            const bPercentage = b.weeks.week8?.[weekKey]?.total ?? 0;
            return isAscending ? bPercentage - aPercentage : aPercentage - bPercentage;
          });

          return {
            ...state,
            wb: {
              ...state.wb,
              data: sortedData, // Используем отсортированные данные
              sortByWeekLastDay8: weekKey, // Сохраняем текущую неделю для сортировки
              sortByWeek: null,
              isAscending, // Добавляем флаг для направления сортировки
              sortPrice: false,
              sortStock: false,
              stockScladFbs: false,
              sorTarticle: false,
            },
          };
        }
      }

      return state; // Возвращаем текущее состояние, если неделя не найдена
    }



    // сортировка для средних заказа
    case "SORT_AVERAGEORDERS_WB": {
      const isAscending = !state.wb.isAscending; // Объявляем переменную перед использованием
      return {
        ...state,
        wb: {
          ...state.wb,
          sortPrice: false,
          sortStock: false,
          stockScladFbs: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          sorTarticle: false,
          averageOrdersBool: true,
          daysOfStockBool: false,
          turnoverVersion2Bool: false,
          data: state.wb.data.sort((a, b) => {
            return isAscending
              ? (b.averageOrders || 0) - (a.averageOrders || 0)
              : (a.averageOrders || 0) - (b.averageOrders || 0);
          }),
        },
      };
    }


    //сортировка для  Остатка хватит на
    case "SORT_DAYS_STOCK_WB": {
      const isAscending = !state.wb.isAscending; // Объявляем переменную перед использованием
      return {
        ...state,
        wb: {
          ...state.wb,
          sortPrice: false,
          sortStock: false,
          stockScladFbs: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          sorTarticle: false,
          averageOrdersBool: false,
          daysOfStockBool: true,
          turnoverVersion2Bool: false,
          data: state.wb.data.sort((a, b) => {
            return isAscending
              ? (b.daysOfStock || 0) - (a.daysOfStock || 0)
              : (a.daysOfStock || 0) - (b.daysOfStock || 0);
          }),
        },
      };
    }

    // сортировка для Оборачиваемость
    case "SORT_TURNOVER_WB": {
      const isAscending = !state.wb.isAscending; // Объявляем переменную перед использованием
      return {
        ...state,
        wb: {
          ...state.wb,
          sortPrice: false,
          sortStock: false,
          stockScladFbs: false,
          isAscending: isAscending,
          sortByWeek: null,
          sortByWeekLastDay8: null,
          sorTarticle: false,
          averageOrdersBool: false,
          daysOfStockBool: false,
          turnoverVersion2Bool: true,
          data: state.wb.data.sort((a, b) => {
            return isAscending
              ? (b.turnover || 0) - (a.turnover || 0)
              : (a.turnover || 0) - (b.turnover || 0);
          }),
        },
      };
    }


    case "SET_SEARCH_VALUEWB":
      return {
        ...state,
        loading: false,
        wb: {
          ...state.wb,
          searchValue: action.payload,
          currentPage: 1, // При новом поиске сбрасываем страницу
          data: [], // Очищаем данные перед новым запросом
          hasMore: true, // Снова включаем подгрузку

        },
      };

    case "SET_SERVER_SORT_WB_START":
      return {
        ...state,
        wb: {
          ...state.wb,
          sortField: action.payload.sortField,
          sortDir: action.payload.sortDir,
          isSorting: true,
          // ничего не очищаем — «мягкий» спиннер
        },
      };

    case "SET_SERVER_SORT_WB_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
        wb: {
          ...state.wb,

          data: action.payload.data || [],
          weeks: Array.isArray(action.payload.weeks)
            ? action.payload.weeks
            : state.wb.weeks,

          hasMore: Boolean(action.payload.hasMore),
          currentPage: action.payload.currentPage || 1,
          totalItems: action.payload.totalItems ?? 0,
          totalPages: action.payload.totalPages ?? 1,
          pageSize: action.payload.pageSize ?? state.wb.pageSize ?? 50,

          sortField: action.payload.sortField,
          sortDir: action.payload.sortDir,
          isSorting: false,

          sortPrice: false,
          sortStock: false,
          stockScladFbs: false,
          sorTarticle: false,
          averageOrdersBool: false,
          daysOfStockBool: false,
          turnoverVersion2Bool: false,
          sortByWeek: null,
          sortByWeekLastDay8: null,
        },
      };

    case "SET_SERVER_SORT_WB_ERROR":
      return {
        ...state,
        wb: { ...state.wb, isSorting: false },
        error: action.payload,
      };

    default:
      return state;
  }
};

export default getWaldberisListReducer;
